import React, { useEffect, useState } from 'react';
import { format, startOfWeek, subWeeks } from 'date-fns';
import { fetchInvoiceAccountCodes } from '../../api/invoices';
import '../css/UserEditModal.css'; // reuse your modal styling

const DownloadWarehouseCharges = ({ isOpen, onClose, onCsv, onInvoice, invoicingEnabled, theme }) => {
    const [options, setOptions] = useState([]);
    const [selected, setSelected] = useState(null);
    const [accountCodes, setAccountCodes] = useState([]);
    const [accountCodeId, setAccountCodeId] = useState('');

    useEffect(() => {
        const today = new Date();
        const lastMonday = subWeeks(startOfWeek(today, { weekStartsOn: 1 }), 1);
        const newOptions = [];

        for (let i = 0; i < 8; i++) {
            const from = subWeeks(lastMonday, i);
            const to = new Date(from);
            to.setDate(to.getDate() + 6); // Sunday

            const label = `${format(from, 'dd/MM/yyyy')} → ${format(to, 'dd/MM/yyyy')}`;
            const value = format(to, 'yyyy-MM-dd'); // Sunday, as required

            newOptions.push({ label, value });
        }

        setOptions(newOptions);
    }, []);

    useEffect(() => {
        if (!isOpen || !invoicingEnabled) return;
        fetchInvoiceAccountCodes().then(response => {
            setAccountCodes(response.status === 200 ? response.data.account_codes || [] : []);
        });
    }, [isOpen, invoicingEnabled]);

    if (!isOpen) return null;

    return (
        <div id={theme} className="overlay">
            <div className="modal-container">
                <h2>Download Charges</h2>
                <form className="form single-column">
                    {options.map((opt) => (
                        <div key={opt.value} className="input-group">
                            <label>
                                <input
                                    type="radio"
                                    name="dateRange"
                                    value={opt.value}
                                    checked={selected === opt.value}
                                    onChange={() => setSelected(opt.value)}
                                />
                                {' '}
                                {opt.label}
                            </label>
                        </div>
                    ))}
                </form>

                {invoicingEnabled && (
                    <div className="input-group">
                        <label htmlFor="warehouse-account-code">Invoice account code</label>
                        <select
                            id="warehouse-account-code"
                            value={accountCodeId}
                            onChange={event => setAccountCodeId(event.target.value)}
                        >
                            <option value="">Select account code</option>
                            {accountCodes.map(accountCode => (
                                <option key={accountCode.id} value={accountCode.id}>
                                    {accountCode.code} — {accountCode.name}
                                </option>
                            ))}
                        </select>
                    </div>
                )}

                <div className="button-group">
                    <button
                        className="submit-button"
                        disabled={!selected || !accountCodeId}
                        type="button"
                        onClick={() => {
                            onCsv(selected);
                            onClose();
                        }}
                    >
                        CSV
                    </button>
                    {invoicingEnabled && <button
                        className="submit-button"
                        disabled={!selected}
                        type="button"
                        onClick={() => {
                            onInvoice(selected, Number(accountCodeId));
                            onClose();
                        }}
                    >
                        Invoice
                    </button>}
                    <button className="close-button" onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DownloadWarehouseCharges;
